import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { CampaignScoringComponent } from '@features/campaign-scoring';
import { BrownfieldFallbackComponent } from 'brownfield-bridge';
import { EntitlementsService } from 'entitlements';
import { UnifiedCompanyDataComponent } from '../components/data-unification.unified-company-data';
import { adminRoutes } from './admin.routes';

export const dataStudioRoutes: Route[] = [
  {
    path: 'account-hub',
    loadChildren: () =>
      import('@features/account-hub').then((m) => m.AccountHubModule),
  },
  {
    path: 'segments',
    loadChildren: () =>
      import('@features/segments').then((m) => m.DataStudioSegmentsModule),
  },
  { path: 'segment', redirectTo: 'segments' },
  {
    path: 'intent-surges',
    redirectTo: 'intent-navigator',
  },
  {
    path: 'intent-navigator',
    loadChildren: () =>
      import('@features/intent-navigator-v2').then(
        (m) => m.IntentNavigatorV2Module,
      ),
  },
  {
    path: 'prospect-engine',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          id: 'prospect-engine',
          requireHubReportsAccess: 'app.dataStudio.prospectEngine',
        }),
    ],
    loadChildren: () =>
      import('@features/prospect-engine').then((m) => m.ProspectEngineModule),
  },
  {
    path: 'settings/visitor-tracking',
    loadChildren: () =>
      import('@features/visitor-tracking').then((m) => m.VisitorTrackingModule),
  },
  {
    path: 'settings/campaign-scoring',
    component: CampaignScoringComponent,
  },
  {
    path: 'config',
    loadChildren: () => import('@features/config').then((m) => m.configRoutes),
  },
  {
    path: 'site-visits',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions(
          {
            requireConfiguration: 'enabled',
            id: 'site-visits',
          },
          ['/data-studio'],
        ),
    ],
    loadChildren: () =>
      import('@features/site-visits').then((m) => m.FeaturesSiteVisitsModule),
  },
  {
    path: 'engagement-spikes',
    loadChildren: () =>
      import('@features/engagement-spike').then(
        (m) => m.FeaturesEngagementSpikeModule,
      ),
  },
  {
    path: 'unified-company-data',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireMyTAdmin: true,
          id: 'adex-admin',
        }),
    ],
    component: UnifiedCompanyDataComponent,
  },
  adminRoutes,
  {
    path: '**',
    component: BrownfieldFallbackComponent,
    data: {
      brownfieldRootUrlEnvKey: 'DS_BROWNFIELD_URL',
      brownfieldPathPrefix: 'data-studio/',
    },
  },
];
